import createReactContext from 'create-react-context';
export var InputContext = createReactContext();